import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import { Small } from 'foundations-components/transitional/components/Small';
import LinkWrapper from 'pricing-pages-ui-components/components/LinkWrapper';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
export const RequiredOnboardingSubtextContent = ({
  langKey,
  currencyCode,
  fullPrice,
  calculatedPrice,
  onboardingIncludedKey,
  handleClick,
  onboardingServicesUrl
}) => {
  const learnMoreLink = /*#__PURE__*/_jsx(LinkWrapper, {
    external: true,
    onClick: handleClick,
    href: onboardingServicesUrl,
    "aria-label": I18n.text(`pricing-pages-ui.merchCardsV2.requiredOnboardingSubtext.onboarding.${langKey}`),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.requiredOnboardingSubtext.learnMore"
    })
  });
  const priceDisplay = /*#__PURE__*/_jsx(PriceDisplay, {
    currencyCode: currencyCode,
    price: calculatedPrice !== null && calculatedPrice !== void 0 ? calculatedPrice : 0
  });
  return /*#__PURE__*/_jsx(Small, {
    maxInlineSize: "90%",
    children: fullPrice && calculatedPrice && fullPrice > calculatedPrice ? /*#__PURE__*/_jsx(Text, {
      typography: "detail-200",
      color: "text-core-subtle",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `pricing-pages-ui.merchCardsV2.requiredOnboardingSubtext.${onboardingIncludedKey}.${langKey}-with-discount`,
        options: {
          discountedPrice: priceDisplay,
          fullPrice: /*#__PURE__*/_jsx(PriceDisplay, {
            currencyCode: currencyCode,
            price: fullPrice
          }),
          learnMoreLink
        }
      })
    }) : /*#__PURE__*/_jsx(Text, {
      typography: "detail-200",
      color: "text-core-subtle",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `pricing-pages-ui.merchCardsV2.requiredOnboardingSubtext.${onboardingIncludedKey}.${langKey}`,
        options: {
          priceDisplay,
          learnMoreLink
        }
      })
    })
  });
};